import React from "react";
import { Table } from "reactstrap";

const PrintableTable = ({ stockItems }) => {
  const totalPurchaseCount = stockItems.reduce(
    (sum, row) => sum + row.purchaseCount,
    0
  );
  const totalSalesCount = stockItems.reduce(
    (sum, row) => sum + row.menuOrderDetailsCount,
    0
  );
  const totalRemainingQty = stockItems.reduce(
    (sum, row) => sum + row.remainingQty,
    0
  );

  return (
    <Table bordered className="table-nowrap">
      <thead>
        <tr>
          <th style={{ width: "80px" }}>S.N</th>
          <th>Menu Item Name</th>
          <th className="text-end">Purchase Count</th>
          <th className="text-end">Sales Count</th>
          <th className="text-end">Remaining Quantity</th>
          <th className="text-center">Stock Status</th>
        </tr>
      </thead>
      <tbody>
        {stockItems.map((item, index) => (
          <tr key={item.id || index}>
            <td>{index + 1}</td>
            <td>{item.menuItemName}</td>
            <td className="text-end">{item.purchaseCount}</td>
            <td className="text-end">{item.menuOrderDetailsCount}</td>
            <td className="text-end">{item.remainingQty}</td>
            <td className="text-center">
              {item.isStockLow ? "Low Stock" : "In Stock"}
            </td>
          </tr>
        ))}
        {stockItems.length > 0 && (
          <tr className="fw-bold">
            <td></td>
            <td>Total</td>
            <td className="text-end">{totalPurchaseCount}</td>
            <td className="text-end">{totalSalesCount}</td>
            <td className="text-end">{totalRemainingQty}</td>
            <td></td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default PrintableTable;
